// src/components/Blog/BlogEditor.js
import React, { useState } from 'react';

const BlogEditor = ({ post, darkMode, onSave, onCancel }) => {
    const [title, setTitle] = useState(post?.title || '');
    const [preview, setPreview] = useState(post?.preview || '');
    const [content, setContent] = useState(post?.content || '');
    const [mainImage, setMainImage] = useState(post?.mainImage || '');
    const [tags, setTags] = useState(post?.tags?.join(', ') || '');

    const handleSubmit = (e) => {
        e.preventDefault();

        const updatedPost = {
            id: post?.id,
            title,
            preview,
            content,
            mainImage,
            tags: tags.split(',').map(tag => tag.trim()).filter(tag => tag),
            date: post?.date || new Date().toLocaleDateString('ru-RU')
        };

        onSave(updatedPost);
    };

    return (
        <div className={darkMode ? 'text-white' : ''}>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">
                    {post ? 'Редактировать статью' : 'Новая статья'}
                </h2>
                <button
                    onClick={onCancel}
                    className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}
                >
                    Отмена
                </button>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="block mb-2 text-sm font-medium">
                        Заголовок <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                        className={`w-full p-3 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'
                            }`}
                    />
                </div>

                <div className="mb-4">
                    <label className="block mb-2 text-sm font-medium">
                        Превью <span className="text-red-500">*</span>
                    </label>
                    <textarea
                        value={preview}
                        onChange={(e) => setPreview(e.target.value)}
                        required
                        rows="3"
                        className={`w-full p-3 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'
                            }`}
                    />
                </div>

                <div className="mb-4">
                    <label className="block mb-2 text-sm font-medium">
                        URL главного изображения
                    </label>
                    <input
                        type="url"
                        value={mainImage}
                        onChange={(e) => setMainImage(e.target.value)}
                        className={`w-full p-3 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'
                            }`}
                        placeholder="https://example.com/image.jpg"
                    />
                    {mainImage && (
                        <div className="mt-2">
                            <img
                                src={mainImage}
                                alt="Preview"
                                className="h-32 object-cover rounded-lg"
                                onError={(e) => e.target.style.display = 'none'}
                            />
                        </div>
                    )}
                </div>

                <div className="mb-4">
                    <label className="block mb-2 text-sm font-medium">
                        Теги (через запятую)
                    </label>
                    <input
                        type="text"
                        value={tags}
                        onChange={(e) => setTags(e.target.value)}
                        className={`w-full p-3 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'
                            }`}
                        placeholder="багажник, автомобиль, путешествия"
                    />
                </div>

                <div className="mb-4">
                    <label className="block mb-2 text-sm font-medium">
                        Содержание <span className="text-red-500">*</span>
                    </label>
                    <textarea
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        required
                        rows="10"
                        className={`w-full p-3 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'
                            }`}
                        placeholder="Поддерживается HTML-форматирование. Для вставки изображений используйте тег <img>"
                    />
                </div>

                <div className="flex justify-end">
                    <button
                        type="submit"
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                    >
                        Сохранить
                    </button>
                </div>
            </form>
        </div>
    );
};

export default BlogEditor;